import { useEffect, useState } from 'react';

import { getAllNewsPosts, getNewsPost } from 'utils/NewsPostAPI';
import { NewsPost } from 'types/NewsPost';

export default function useNewsPosts(id?: string) {
  const [newsPost, setNewsPost] = useState<NewsPost>();
  const [newsPosts, setNewsPosts] = useState<NewsPost[]>([]);
  const [homepageNewsPosts, setHomepageNewsPosts] = useState<NewsPost[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [featuredNews, setFeaturedNews] = useState<NewsPost>();

  useEffect(() => {
    const fetchAllNewsPosts = async () => {
      let allNewsPosts = await getAllNewsPosts();

      if (!allNewsPosts || !allNewsPosts.length) {
        setNewsPosts([]);
        setIsLoading(false);
        return;
      }

      allNewsPosts.sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1));

      setHomepageNewsPosts(allNewsPosts);

      // Find the first featured news post and remove it from the list of all
      // other posts
      const featured = allNewsPosts.find((news) => news.isFeatured);
      if (featured) {
        allNewsPosts = allNewsPosts.filter(({ id }) => id !== featured.id);
      }

      setFeaturedNews(featured);
      setNewsPosts(allNewsPosts);
      setIsLoading(false);
    };

    const fetchNewsPost = async (id: string) => {
      setNewsPost(await getNewsPost(id));
      setIsLoading(false);
    };

    if (id) {
      fetchNewsPost(id);
    } else {
      fetchAllNewsPosts();
    }
  }, [id]);

  return {
    newsPost,
    newsPosts,
    homepageNewsPosts,
    isLoading,
    featuredNews,
  };
}
